

import { CurrencyPipe } from '@angular/common';
import { createReducer, on, Action } from '@ngrx/store';
import { DialogModel } from 'app/shared/components/dialog/dialogModel';
import { CurrencyType, Language } from 'app/shared/model/enums';
import { setBlockDocument, setCurrency, setCurrentPageTitle, setDisplayLoginDialog, setIsLoading, setLanguage } from '../actions/‏‏shared-common.action';
import { LAST_CONNECTED_LANGUAGE } from 'app/shared/model/local-storage-keys';

const lastLanguage = localStorage.getItem(LAST_CONNECTED_LANGUAGE);

export class SharedCommonState {
    language: Language;
    currency: CurrencyType;
    isLoading: boolean;
    dialog: DialogModel;
    displayLoginDialog: boolean;
    blockDocument: boolean;
    currentPageTitle: string;
}
let initialState: SharedCommonState = {
    language: (!isNaN(parseInt(lastLanguage)) && parseInt(lastLanguage)) || Language.he,
    currency: CurrencyType.ILS,
    isLoading: false,
    dialog: {
        title: '',
        content: '',
        style: null,
        visible: false,
    },
    displayLoginDialog: false,
    blockDocument: false,
    currentPageTitle: ''
}

const createSharedCommonReducer = createReducer(
    initialState,
    on(setIsLoading, (state, { isLoading, divElement }) => {
        return {
            ...state, isLoading, divElement
        };
    }), on(setDisplayLoginDialog, (state, { displayLoginDialog }) => {
        return {
            ...state, displayLoginDialog
        };
    })
    , on(setBlockDocument, (state, { blockDocument }) => {
        return {
            ...state, blockDocument
        };
    }),
    on(setCurrentPageTitle, (state, { displayPageTitle, pageTitle }) => {
        return {
            ...state, currentPageTitle: displayPageTitle ? pageTitle : ''
        };
    }),
    on(setLanguage, (state, { language }) => {
        localStorage.setItem(LAST_CONNECTED_LANGUAGE, language.toString());
        return {
            ...state, language
        };
    }),
    on(setCurrency, (state, { currency }) => {
        return {
            ...state, currency
        };
    }),
);

export function SharedCommonReducer(state: SharedCommonState | undefined, action: Action) {
    return createSharedCommonReducer(state, action);
}

